import React, { useState } from 'react';
import { Heart, Loader2, ShieldCheck } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

const QUICK_AMOUNTS = [100, 500, 1000, 5000];

export const DonateForm = ({ busy, error, onSubmit }) => {
  const { t } = useLanguage();
  const [amount, setAmount] = useState(500);
  const [custom, setCustom] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [onWall, setOnWall] = useState(false);
  const [place, setPlace] = useState('');
  const [localErr, setLocalErr] = useState('');

  const finalAmount = custom ? parseInt(custom, 10) || 0 : amount;

  const submit = (e) => {
    e.preventDefault();
    if (finalAmount < 1 || finalAmount > 500000) return setLocalErr(t('donation.invalidAmount'));
    if (!name.trim()) return setLocalErr(t('donation.invalidName'));
    if (!/^[6-9]\d{9}$/.test(phone.replace(/\D/g, '').slice(-10)) || phone.replace(/\D/g, '').length < 10) {
      return setLocalErr(t('donation.invalidPhone'));
    }
    setLocalErr('');
    onSubmit({ amount: finalAmount, name: name.trim(), phone: phone.replace(/\D/g, '').slice(-10), show_on_wall: onWall, place: onWall ? place.trim() : '' });
  };

  const msg = localErr || error;
  return (
    <form className="jbss-donate-form" onSubmit={submit} noValidate data-testid="donate-form">
      <Label className="jbss-donate-label">{t('donation.chooseAmount')}</Label>
      <div className="jbss-donate-amounts">
        {QUICK_AMOUNTS.map((a) => (
          <button type="button" key={a} data-testid={`donate-amount-${a}`}
            className={`jbss-donate-chip ${!custom && amount === a ? 'jbss-donate-chip-active' : ''}`}
            onClick={() => { setAmount(a); setCustom(''); }}>
            ₹{a.toLocaleString('en-IN')}
          </button>
        ))}
      </div>
      <Input type="number" min="1" inputMode="numeric" placeholder={t('donation.customAmount')} value={custom}
        onChange={(e) => setCustom(e.target.value)} data-testid="donate-custom-amount" />
      <Label htmlFor="donor-name" className="jbss-donate-label">{t('donation.name')}</Label>
      <Input id="donor-name" value={name} onChange={(e) => setName(e.target.value)} maxLength={80} data-testid="donate-name" />
      <Label htmlFor="donor-phone" className="jbss-donate-label">{t('donation.phone')}</Label>
      <div className="jbss-donate-phone">
        <span>+91</span>
        <Input id="donor-phone" inputMode="numeric" maxLength={10} placeholder="98XXXXXXXX" value={phone}
          onChange={(e) => setPhone(e.target.value.replace(/\D/g, ''))} data-testid="donate-phone" />
      </div>
      <label className="jbss-donate-consent" data-testid="donate-wall-consent">
        <input type="checkbox" checked={onWall} onChange={(e) => setOnWall(e.target.checked)} data-testid="donate-wall-checkbox" />
        <span>{t('donation.wallConsent')}</span>
      </label>
      {onWall && (
        <Input placeholder={t('donation.place')} maxLength={60} value={place} onChange={(e) => setPlace(e.target.value)} data-testid="donate-place" />
      )}
      <p className="jbss-donate-hint">{t('donation.messageNote')}</p>
      {msg && <p className="jbss-donate-error" data-testid="donate-error">{msg}</p>}
      <button type="submit" className="jbss-btn jbss-btn-gold jbss-donate-submit" disabled={busy} data-testid="donate-submit">
        {busy ? <Loader2 className="jbss-spin" size={16} /> : <Heart size={16} fill="currentColor" />}
        <span>{t('donation.pay')} ₹{(finalAmount || 0).toLocaleString('en-IN')}</span>
      </button>
      <p className="jbss-donate-secure"><ShieldCheck size={14} /> {t('donation.secure')}</p>
    </form>
  );
};
